import { createSelector } from 'reselect';

export const permissions = state => state.user.permissions;

export const user = state => state.user.userName;

export const columns = state => state.user.columns;

export const isWriteable = createSelector(permissions, permissions =>
  permissions.some(({ operation }) => operation === 'write'),
);
